exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".custom-panel-toggle-btn{display:none}@media only screen and (max-width: 767px){.custom-panel-toggle-btn{display:block}}\n", ""]);

